<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="24">
        <div>
          <div v-if="integrationWizardIndex >= 1">
            <h3 class="cnct-devo-header">Connect Devo API to Confluera</h3>
            <el-steps :active="integrationWizardIndex" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item style="overflow: unset" :key="1">
              <span class="cnct-devo-header" style="margin-bottom: 22px">How to connect to Devo</span>
              <p class="top-header">
                This wizard walks you through the simple steps to connect Confluera CxDR to your Devo account. If you
                have multiple Devo accounts, simply run this wizard to configure each account.
              </p>

              <el-row type="flex" :gutter="24" style="margin: -32px 0px 0px;">
                <el-col :span="4" class="integration-logo-container">
                  <el-card shadow="hover" class="integration-logo-card">
                    <span class="display-block" style="margin-top: 14px; margin-left: 6px">
                      <img class="devo-logo" src="/static/images/logos/devo-color.svg" alt="devo-logo"/>
                    </span>
                  </el-card>
                </el-col>
                <el-col :span="20" class="connect-devo">
                  <el-row>
                    <el-row>
                      <el-col :span="23">
                        <span class="bold">Step 1</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        Create an OAuth token in the Devo administrative
                        <br />console.
                        <span class="text-btn" @click="loadDocumentation('page-partner-signals-devo')">
                          Learn More
                        </span>
                      </el-col>
                    </el-row>
                  </el-row>
                  <br />
                  <el-row>
                    <el-row>
                      <el-col :span="23">
                        <span class="bold">Step 2</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="23">
                        Identify the event types to be ingested from Devo
                        <br />and the tables to query.
                        <span class="text-btn" @click="loadDocumentation('page-partner-signals-devo')">
                          Learn More
                        </span>
                      </el-col>
                    </el-row>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
            <el-carousel-item style="overflow: unset;" :key="2">
              <div class="box flex">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-row :type="'flex'" :gutter="8" class="mt-20">
                    <el-col>
                      <el-row :gutter="20">
                        <el-col :span="8" class="conf-block">
                          <el-form-item label="URL"></el-form-item>

                          <el-input
                            v-model="cred.url"
                            placeholder="Enter a URL"
                            @keydown.native.space.prevent
                          ></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Devo API Token"></el-form-item>

                          <el-input v-model="cred.token" placeholder="Enter a Devo API Token"></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Table"></el-form-item>

                          <el-input v-model="cred.table" placeholder="Enter table"></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Log Type"></el-form-item>

                          <el-input v-model="cred.logType" placeholder="Enter Log Type"></el-input>
                        </el-col>

                        <el-col :span="8" class="conf-block">
                          <el-form-item label="Nickname"></el-form-item>

                          <el-input v-model="cred.nickName" placeholder="Enter Nickname"></el-input>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" class="initiated mt-20">
              <h4 class="center-text">Initiated!</h4>
              <div class="box flex" v-loading="apiCall.outbound" element-loading-spinner="el-icon-loading"></div>
              <div class="box flex mt-20 mb-20">
                <p>
                  Please wait as we are attempting to connect to your Devo account.
                </p>
              </div>
              <div class="box flex mt-20">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">View Configured Account</el-button>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="4" class="initiated error mt-20">
              <h4 class="center-text">Error!</h4>
              <div class="box flex">
                <span class="center-text error-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <div class="box mt-20 mb-20 error-message">
                <p>
                  We could not connect to your Devo account.
                </p>
                <p>
                  Troubleshoot to fix your configuration.
                </p>
                <div v-if="apiCall.error" class="box mt-20">
                  <p>
                    {{ apiCall.errorMsg.code }}:
                    {{ apiCall.errorMsg.message }}
                  </p>
                </div>
              </div>
              <div class="box flex mt-40">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">Troubleshoot / FAQs</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button go-back-button"
              @click="backIntegrationStep"
              >Go Back</span
            >
            <el-button
              class="start-button"
              v-if="integrationWizardIndex < 1"
              size="medium"
              round
              @click="nextIntegrationStep"
              >Start</el-button
            >
            <el-button v-if="integrationWizardIndex == 1" size="medium" round @click="saveDevoSettings">
              Submit
            </el-button>           
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getParsedJSON } from '@/utilities/json.helper'
import { DEVO_INTEGRATION_CONFIG_CREATE_REQUEST } from '@/store/modules/integrations/devo-integration.type.js'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'DevoIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      apiDispatchState: DEVO_INTEGRATION_CONFIG_CREATE_REQUEST,
      integrationLastStep: 3,
      copyDevoSettings: {},
      cred: {
        nickName: '',
        url: '',
        token: '',
        table: '',
        logType: ''
      }
    }
  },
  methods: {
    testingApiCall () {
      this.$store.dispatch(DEVO_INTEGRATION_CONFIG_CREATE_REQUEST, this.cred)
    },
    saveDevoSettings () {
      // logType: null
      // nickName: "team_test_1"
      // table: "my.app.mytest"
      // token: null
      // url: "https://apiv2-us.devo.com/search/query"
      let flag = false
      if (
        this.cred.url === '' ||
        this.cred.token === '' ||
        this.cred.table === '' ||
        this.cred.logType === '' ||
        this.cred.nickName === ''
      ) {
        flag = true
      }

      if (!flag) {
        this.$store.dispatch(DEVO_INTEGRATION_CONFIG_CREATE_REQUEST, this.cred).then(
          _ => {
            this.$message({
              type: 'success',
              message: 'Credential added successfully added'
            })
            this.nextIntegrationStep()
            this.apiCall.outbound = false
            this.resetDevoSettings()
          },
          errMsg => {
            if (errMsg.data && errMsg.data.message) {
              errMsg = getParsedJSON(errMsg.data.message)
            }

            this.integrationWizardIndex++
            this.nextIntegrationStep()

            this.apiCall.error = true
            this.apiCall.errorMsg = errMsg
          }
        )
      } else {
        this.$message({
          type: 'error',
          message: 'All fields must be populated.'
        })
        this.resetDevoSettings()
      }
    },
    resetDevoSettings () {
      this.cred.url = ''
      this.cred.token = ''
      this.cred.table = ''
      this.cred.logType = ''
      this.cred.nickName = ''
    }
  },
  created () {},
  computed: {},
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.integration-settings {
  overflow: unset;
}

.initiated {
  h4 {
    margin-bottom: 40px;
  }

  p {
    text-align: center;
    width: 60%;
    margin: auto;
    display: block;
  }

  >>> .el-button {
    margin: auto;
  }

  >>> .el-icon-loading,
  .material-icons {
    font-size: 2em;
  }

  .center-text.error-icon {
    margin: auto;
    font-size: 2em;
  }
}

>>> .el-carousel--horizontal {
  overflow-x: hidden;
  width: 110%;
}

>>> .el-step__head.is-success {
  color: #1a90fa;
}

>>> .el-step__head {
  fill: #1a90fa;
  border-color: #1a90fa;
}

>>> .el-step__line {
  background-color: #1a90fa;
}

>>> .el-step__icon-inner {
  color: #1a90fa;
}

.el-form-item {
  margin-bottom: 0px;
}
.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.error-message {
  width: 60%;
  margin: 30px auto;

  p {
    width: 100%;
  }
}

.top-header {
  height: 94px;
  width: 834px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0.17px;
  line-height: 22px;
}

.top-header-title {
  font-weight: 500px;
  font-size: 24px;
  margin-bottom: 22px;
}
.devo-content {
  height: 308px;
  width: 616px;
  color: #454b60;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.start-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  margin-left: 55%;
  text-align: center;
  margin-top: 50px;
}

.verify-button,
.submit-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #1a90fa;
  /* margin-left:55%; */
  text-align: center;
}

.go-back-button {
  height: 36px;
  width: 113px;
  border-radius: 4px;
  background-color: #ffffff;
  margin-left: 55%;
  text-align: center;
  border: 1px solid #767676;
  text-decoration: none;
}
.conf-block {
  display: inline-block;
  width: 34.86%;
  height: 27.34%;
  line-height: 20px;
  letter-spacing: 0.09px;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 50px;
}

.header-carousal-2 {
  height: 66px;
  width: 575px;
  color: #454b60;
  /* font-family: Montserrat; */
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 22px;
}

.carousal-3-content {
  margin-bottom: 20px;
  font-size: 14px;
}

.integration-settings {
  .el-steps {
    padding: 20px 10px 25px 10px;
    margin: 0 0 20px 0;
    border-bottom: solid 1px #f0f0f0;
  }

  >>> .el-carousel {
    margin: 10px 0 20px 0;

    .el-carousel__container {
      height: 400px;
    }
  }
}

.cnct-devo-header {
  margin-bottom: 20px;
  margin-top: 10px;
  font-weight: 500px;
  font-size: 24px;
}

.el-step-fixes {
  width: 20%;
  padding-left: 0px;
  border: none;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

.connect-devo {
  margin-left: 12px;
  width: 379px;
  height: 198px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.devo-logo {
  margin-top: 36px;
  width: 139px;
  margin-left: -12px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/DevoIntegrationWorkflow.vue